import { UM } from '../_components/tokens';
import type { LayerSource } from './types';

/** Rond œil : bascule visible / masqué. */
export function EyeToggle({ visible, onClick }: { visible: boolean; onClick: () => void }) {
  const c = visible ? UM.accent : '#b0c4d4';
  return (
    <span
      onClick={onClick}
      title={visible ? 'Masquer la couche' : 'Afficher la couche'}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 22, height: 22, borderRadius: '50%',
        background: visible ? UM.accentLight : '#f1f5f9',
        cursor: 'pointer', flexShrink: 0,
      }}
    >
      <svg width="13" height="9" viewBox="0 0 13 9">
        <ellipse cx="6.5" cy="4.5" rx="6" ry="4" stroke={c} strokeWidth="1.3" fill="none" />
        <circle cx="6.5" cy="4.5" r="2" fill={c} />
      </svg>
    </span>
  );
}

/** Badge source ENGIE / Open Data. */
export function SourceBadge({ source }: { source: LayerSource }) {
  const isEngie = source === 'engie';
  return (
    <span style={{
      fontSize: 10, fontWeight: 600, letterSpacing: 0.3,
      background: isEngie ? UM.badgeBlue : '#f1f5f9',
      color: isEngie ? UM.badgeBlueText : UM.textMuted,
      padding: '2px 6px', borderRadius: 3,
      textTransform: 'uppercase', flexShrink: 0,
    }}>
      {isEngie ? 'ENGIE' : 'Open Data'}
    </span>
  );
}

/** Icône poubelle inline. */
export function TrashIcon() {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path d="M2 3.5h8m-6 0V2.5a1 1 0 011-1h2a1 1 0 011 1v1M3 3.5V11a1 1 0 001 1h4a1 1 0 001-1V3.5" stroke={UM.textMuted} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 6v3.5M7 6v3.5" stroke={UM.textMuted} strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  );
}
